<!-- Saving (design-spec §7 state 6): in-flight, both actions suppressed. -->
@if (saving) {
  <div class="savebar">
    <span class="savebar-summary muted" aria-live="polite">
      {{ 'Saving {{count}} objects…' | translate: { count: objectCount } }}
    </span>
    <span class="grow">
      <button type="button" class="btn btn-primary is-loading" disabled>
        <mat-icon class="spin">progress_activity</mat-icon> {{ 'Saving' | translate }}
      </button>
    </span>
  </div>
} @else {
  <!-- Dirty (design-spec §7 state 5, §5.6): amber bar, verb diff, Discard + Save role. -->
  @if (dirty) {
    <div class="savebar dirty">
      <span class="status-badge status-badge--unsaved">{{ 'Unsaved' | translate }}</span>
      <span class="savebar-summary" aria-live="polite">
        @if (diff.objectCount) {
          @if (diff.added) {
            <span class="chg-add">+{{ diff.added }}</span>
          }
          @if (diff.removed) {
            <span class="chg-rem">−{{ diff.removed }}</span>
          }
          {{ 'across' | translate }}
          <b>{{ diff.objectCount }} {{ (diff.objectCount === 1 ? 'object' : 'objects') | translate }}</b>
        } @else {
          {{ (isNew ? 'New role — not yet saved' : 'Role details changed') | translate }}
        }
      </span>
      @if (diff.objectCount) {
        <button type="button" class="link-btn" (click)="review.emit()">{{ 'Review' | translate }}</button>
      }
      <span class="grow">
        <button type="button" class="btn btn-ghost" (click)="discard.emit()">{{ 'Discard' | translate }}</button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!canSave"
          [attr.aria-label]="'Save role — {{count}} objects' | translate: { count: objectCount }"
          (click)="save.emit()">
          <mat-icon>save</mat-icon> {{ 'Save role' | translate }}
        </button>
      </span>
    </div>
  } @else {
    <div class="savebar">
      <span class="savebar-summary muted">
        {{ 'No unsaved changes.' | translate }}
      </span>
      <span class="grow">
        <button type="button" class="btn btn-primary" disabled aria-disabled="true">
          <mat-icon>save</mat-icon> {{ 'Save' | translate }}
        </button>
      </span>
    </div>
  }
  <!-- Clean (design-spec §5.6, §8): the whole-role save contract, Save blocked. -->
}

